import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Roles } from '@app/common/roles';
import { ActionLinkModule } from '@app/components/actions/action-link/action-link.component';
import { NgSubscribeModule } from '@app/directives/ng-subscribe.directive';
import { PageType } from '@app/models/page';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { LicenseService } from '@app/services/license.service';
import { SecurityService } from '@app/services/security.service';
import { Environment } from '@environments/interface.environment';
import { Observable, Subscription } from 'rxjs';
import { PageCenterModule } from '@app/views/pages/page-center/page-center.component';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-news-center-view',
  templateUrl: './news-center-view.component.html',
  styleUrls: ['./news-center-view.component.scss']
})
export class NewsCenterViewComponent implements OnInit {

  allowedToCreateNew$: Observable<boolean>;
  queryParamSubcription: Subscription;
  channel$: Observable<string>;
  lightEnabled: boolean;
  licensed$: Observable<Boolean>;
  pageType: PageType = PageType.News;
  newsCenterUrl: string;
  showNewsCenterLink = this.featureSettingsStoreService.state.showSharePointNewsCenterLink;
  filterChannelGuid$: Observable<string>;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
              private securityService: SecurityService,
              private licenseService: LicenseService,
              private featureSettingsStoreService: FeatureSettingsStoreService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.newsCenterUrl = this.featureSettingsStoreService.state.sharePointNewsCenterUrl;
    this.allowedToCreateNew$ = this.securityService.hasUserAnyAppRole([Roles.Admin, Roles.Editor]);
    this.lightEnabled = this.environment.enableWorkplaceLight;
    this.licensed$ = this.licenseService.hasUserAny365License();
    this.filterChannelGuid$ = this.activatedRoute.queryParamMap
      .pipe(
        map(params => {
          if (params.has('channel')) {
            return params.get('channel');
          }
          return undefined;
        }));
  }

}
@NgModule({
  declarations: [
    NewsCenterViewComponent
  ],
  exports: [
    NewsCenterViewComponent
  ],
  imports: [
    MatButtonModule,
    CommonModule,
    NgSubscribeModule,
    RouterModule,
    PageCenterModule,
    ActionLinkModule
  ]
})
export class NewsCenterViewModule { }
